module.exports = __webpack_public_path__ + "static/media/restaurant-512.327cf3d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/restaurant-512.png
// module id = 780
// module chunks = 0